import { Component } from '@angular/core'
import { type IStatusPanelAngularComp } from 'ag-grid-angular'
import { type IStatusPanelParams } from 'ag-grid-community'

// Define a custom interface for our params
interface RecoBuyQtyStatusBarParams extends IStatusPanelParams {
  statusPanelParams: {
    maxBudget: number
  }
}

@Component({
  standalone: false,
  selector: 'app-reco-buy-qty-status-bar',
  templateUrl: './reco-buy-qty-status-bar.component.html',
  styleUrls: ['./reco-buy-qty-status-bar.component.scss']
})
export class RecoBuyQtyStatusBarComponent implements IStatusPanelAngularComp {
  public params: RecoBuyQtyStatusBarParams
  public maxBudget: number = 0

  agInit (params: IStatusPanelParams): void {
    // Assert type to our extended interface
    this.params = params as RecoBuyQtyStatusBarParams
    if (this.params.statusPanelParams && this.params.statusPanelParams.maxBudget) {
      this.maxBudget = this.params.statusPanelParams.maxBudget
    }
  }

  refresh (params: IStatusPanelParams): boolean {
    const typedParams = params as RecoBuyQtyStatusBarParams
    if (typedParams.statusPanelParams && typedParams.statusPanelParams.maxBudget !== this.maxBudget) {
      this.maxBudget = typedParams.statusPanelParams.maxBudget
    }
    return true
  }
}
